const ResearchTrainingLearningPaths = () => {
    return (
        <>
            <div className='row-listing'>
                <div class="row align-items-center gy-4 gy-lg-0">
                    <div class="col-12 col-lg-6 order-2 order-lg-1">
                        <h3 class="fs-22 fw-bold mb-4">For New Graduate Students</h3>
                        <ul class="list-item-1">
                            <li>Experiments: from idea to design</li>
                            <li>Data analysis: planning and preparing</li>
                            <li>Interpreting scientific results</li>
                            <li>Writing a research paper</li>
                            <li>Choosing the best journal for your paper</li>
                            <li>Research integrity: publication ethics</li>
                            <li>Effective science communication</li>
                            <li>Advancing your scientific presentations</li>
                            <li>Creating successful research posters</li>
                        </ul>
                    </div>
                    <div class="col-12 col-lg-6 order-1">
                        <img class="img-fluid" src="https://www.hbku.edu.qa/sites/default/files/img-path-1.jpg" alt="User Support and Training" width="640" height="373" />
                    </div>
                </div>

                <div class="row align-items-center gy-4 gy-lg-0">
                    <div class="col-12 col-lg-6">
                        <img class="img-fluid" src="https://www.hbku.edu.qa/sites/default/files/img-path-2.jpg" alt="User Support and Training" width="640" height="373" />
                    </div>
                    <div class="col-12 col-lg-6">
                        <h3 class="fs-22 fw-bold mb-4">For Postdocs and Early-Career Researchers</h3>
                        <ul class="list-item-1">
                            <li>Publishing a Research paper</li>
                            <li>Maximizing the impact of your paper</li>
                            <li>Focus on peer review</li>
                            <li>Participating in a collaboration</li>
                            <li>Introduction to collaboration</li>
                            <li>Networking for researchers</li>
                            <li>Finding funding opportunities</li>
                            <li>Getting an academic research position</li>
                        </ul>
                    </div>
                </div>

                <div class="row align-items-center gy-4 gy-lg-0">
                    <div class="col-12 col-lg-6 order-2 order-lg-1">
                        <h3 class="fs-22 fw-bold mb-4">For Faculty and Research Supervisors</h3>
                        <ul class="list-item-1">
                            <li>Leading a collaboration</li>
                            <li>Managing research data</li>
                            <li>Building a strong online researcher profile</li>
                            <li>Narrative tools for researchers</li>
                            <li>Persuasive grant writing</li>
                        </ul>
                    </div>
                    <div class="col-12 col-lg-6 order-1">
                        <img class="img-fluid" src="https://www.hbku.edu.qa/sites/default/files/img-path-3.jpg" alt="User Support and Training" width="640" height="373" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResearchTrainingLearningPaths;